"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deferredGetConfiguration = exports.resetConfiguration = exports.configure = exports.getConfiguration = void 0;
// @file setup necessary data for arvo
var fetch_1 = require("@padlet/fetch");
var hasWindow = typeof window !== 'undefined' && window !== null;
var getDefaultJsonApiHost = function (hostname) {
  if (/\.dev$/.exec(hostname)) {
    return 'api.padlet.dev';
  } else if (/\.io$/.exec(hostname)) {
    if (hostname.endsWith('.padlet.io')) {
      // for per branch staging environments (xxx.padlet.io), just reuse the hostname, api.padlet.io will connect to the "main" staging instance group
      return hostname;
    }
    return 'api.padlet.io';
  } else {
    return 'api.padlet.com';
  }
};
// Use when necessary
// const isReactNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative'
// const isBrowser = typeof document !== 'undefined'
var defaultHost = hasWindow && window.location && window.location.host ? window.location.host : 'padlet.com';
var defaultCdnHost = 'assets.padletcdn.com';
var betaJsonApiHost = 'api-beta.padlet.com';
var defaultJsonApiHost = hasWindow && window.location && window.location.hostname ? getDefaultJsonApiHost(window.location.hostname) : 'api.padlet.com';
var defaultJsonApiVersion = 3;
var defaultEnvironment = {
  host: defaultHost,
  cdnHost: defaultCdnHost,
  jsonApiHost: defaultJsonApiHost,
  jsonApiVersion: defaultJsonApiVersion,
  token: {},
  isBeta: false
};
var currentEnvironment = {
  token: {}
};
var configStatePromise = null;
var isConfigured = false;
/**
 * Setup our environment so Arvo is equipped with data required for
 * successful querying of APIs.
 * @param options Configuration options.
 * @return The same environment (merged with default options) that have been passed.
 */
function configure(options) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      configStatePromise = new Promise(function (resolve) {
        var defaultFetchOptions = defaultEnvironment.fetchOptions || {};
        var token = {};
        var env = {
          token: token
        };
        if (options) {
          if (options.host) env.host = options.host;
          if (options.cdnHost) env.cdnHost = options.cdnHost;
          if (options.jsonApiHost) env.jsonApiHost = options.jsonApiHost;
          if (options.jsonApiVersion) env.jsonApiVersion = options.jsonApiVersion;
          if (options.token) token = options.token;
          if (options.isBeta) {
            env.isBeta = options.isBeta;
            env.jsonApiHost = betaJsonApiHost;
          }
        }
        // A string token is most likely a JSON hash that's been stringified
        if (token && typeof token === 'string') {
          // this will fail loudly if the string isn't a JSON string.
          token = JSON.parse(token);
        }
        env.token = token;
        var _a = env.token,
          oauthToken = _a.oauthToken,
          csrfToken = _a.csrfToken;
        if (oauthToken) {
          defaultFetchOptions.authorization = [fetch_1.HTTPAuthenticationScheme.bearer, oauthToken];
        } else if (csrfToken) {
          if (typeof csrfToken !== 'function') {
            var csrf_1 = csrfToken;
            env.token.csrfToken = function () {
              return csrf_1;
            };
          }
        }
        currentEnvironment = __assign(__assign(__assign({}, defaultEnvironment), env), {
          fetchOptions: defaultFetchOptions
        });
        isConfigured = true;
        resolve(currentEnvironment);
      });
      return [2 /*return*/, configStatePromise];
    });
  });
}
exports.configure = configure;
/**
 * Gets the current environment as it is setup.
 * @returns Curently configured environment.
 */
function getConfiguration() {
  if (!isConfigured) {
    throw new Error("Not configured. Arvo requires a call to \"configure\" before it should be used.");
  }
  return currentEnvironment;
}
exports.getConfiguration = getConfiguration;
function deferredGetConfiguration() {
  if (configStatePromise == null) throw new Error('Arvo is not yet configured.');else return configStatePromise;
}
exports.deferredGetConfiguration = deferredGetConfiguration;
/**
 * Resets the configuration, so the environment Arvo operates
 * in is a fresh slate.
 * @returns [[Environment]] we use to prepare for queries to APIs.
 */
function resetConfiguration() {
  currentEnvironment = {
    token: {}
  };
  isConfigured = false;
  configStatePromise = null;
  return currentEnvironment;
}
exports.resetConfiguration = resetConfiguration;